if (!customElements.get('collapsible-content')) {
  customElements.define(
    'collapsible-content',
    class CollapsibleContent extends HTMLElement {
      connectedCallback() {
        if (this.dataset.accordionInit === 'true') return;
        this.dataset.accordionInit = 'true';

        this.items = Array.from(this.querySelectorAll('details'));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.items.forEach((details) => {
          const summary = details.querySelector('summary');
          if (!summary) return;

          summary.addEventListener('click', (event) => {
            event.preventDefault();
            this.toggle(details);
          });
        });
      }

      async toggle(details) {
        if (this.animating) return;
        this.animating = true;

        try {
          const isOpen = details.hasAttribute('open');
          const animations = this.items
            .filter((item) => item !== details && item.hasAttribute('open'))
            .map((item) => this.close(item));

          if (isOpen) {
            animations.push(this.close(details));
          } else {
            animations.push(this.open(details));
          }

          await Promise.all(animations);
        } finally {
          this.animating = false;
        }
      }

      open(details) {
        const panel = details.querySelector('.accordion__content');
        if (!panel) {
          details.setAttribute('open', '');
          return Promise.resolve();
        }

        details.setAttribute('open', '');

        if (this.reduceMotion) return Promise.resolve();

        const end = panel.scrollHeight;
        panel.style.overflow = 'hidden';
        panel.style.height = '0px';
        // Force reflow before transitioning
        panel.getBoundingClientRect();
        panel.style.transition = 'height 0.35s ease';
        panel.style.height = `${end}px`;

        return this.waitForTransition(panel).then(() => {
          panel.style.height = '';
          panel.style.overflow = '';
          panel.style.transition = '';
        });
      }

      close(details) {
        const panel = details.querySelector('.accordion__content');
        if (!panel) {
          details.removeAttribute('open');
          return Promise.resolve();
        }

        if (this.reduceMotion) {
          details.removeAttribute('open');
          return Promise.resolve();
        }

        const start = panel.scrollHeight;
        panel.style.overflow = 'hidden';
        panel.style.height = `${start}px`;
        panel.getBoundingClientRect();
        panel.style.transition = 'height 0.35s ease';
        panel.style.height = '0px';

        return this.waitForTransition(panel).then(() => {
          details.removeAttribute('open');
          panel.style.height = '';
          panel.style.overflow = '';
          panel.style.transition = '';
        });
      }

      waitForTransition(element) {
        return new Promise((resolve) => {
          let settled = false;
          const done = (event) => {
            if (settled) return;
            if (event && event.target !== element) return;
            if (event && event.propertyName && event.propertyName !== 'height') return;
            settled = true;
            clearTimeout(fallback);
            element.removeEventListener('transitionend', done);
            resolve();
          };
          element.addEventListener('transitionend', done);
          const fallback = setTimeout(() => done(), 400);
        });
      }
    }
  );
}
